/* Pakhor — predictive search
 * Debounced query against /search/suggest with rendered HTML section.
 */
(function () {
  'use strict';
  const root = document.querySelector('[data-predictive-search]');
  if (!root) return;
  const settings = window.PakhorTheme || {};
  const input = root.querySelector('input[type="search"]');
  const results = root.querySelector('[data-results]');
  const status = root.querySelector('[data-status]');
  let aborter;
  let timer;

  async function search(q) {
    if (!q || q.length < 2) {
      results.innerHTML = '';
      results.hidden = true;
      return;
    }
    if (aborter) aborter.abort();
    aborter = new AbortController();
    try {
      const url = `${settings.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=5&section_id=predictive-search`;
      const res = await fetch(url, { signal: aborter.signal, headers: { Accept: 'text/html' } });
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-predictive-results-inner]');
      results.innerHTML = fresh ? fresh.innerHTML : '';
      results.hidden = false;
      if (status) status.textContent = '';
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error('[pakhor] predictive search failed', e);
    }
  }

  input.addEventListener('input', (e) => {
    clearTimeout(timer);
    if (status) status.textContent = 'Searching\u2026';
    timer = setTimeout(() => search(e.target.value.trim()), 220);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2) results.hidden = false;
  });

  if (window.Pakhor && window.Pakhor.on) {
    window.Pakhor.on('dialog:close', (payload) => {
      if (payload && payload.el === root) {
        results.hidden = true;
        results.innerHTML = '';
      }
    });
  }
})();
